"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsAPI = void 0;
const ProductList_1 = require("./ProductList");
class ProductsAPI {
    constructor(client) {
        /**
         * Method returning list of products with ability to request next page
         * @param params List parameters
         */
        this.getList = (variables) => {
            const list = new ProductList_1.ProductList(this.client);
            list.init(variables);
            return list;
        };
        this.client = client;
    }
}
exports.ProductsAPI = ProductsAPI;
//# sourceMappingURL=products.js.map